import { createFileRoute } from '@tanstack/react-router';
import {
  payrollAgreementListScreen,
  payrollAgreementSearch,
  loadPayrollAgreementMessages,
  loadPayrollAgreementScreens,
} from '@/modules/payroll-agreement/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';
export const Route = createFileRoute('/_app/cadastro/convenios/')({
  validateSearch: payrollAgreementSearch,
  staticData: { screen: payrollAgreementListScreen },
  loader: () => loadPayrollAgreementMessages(),
  component: lazyScreen(loadPayrollAgreementScreens, 'PayrollAgreementListScreen'),
});
